
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guides/author/[filename]",
      function () {
        return require("private-next-pages/guides/author/[filename].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guides/author/[filename]"])
      });
    }
  